import { defHttp } from '@/utils/request';
import { UserInfo } from './model/userModel';

export const getInfo = () =>
  defHttp.get<ResponseData<UserInfo>>({
    url: '/user/info/getUserInfo',
  });

export const updatePassword = (passWord) =>
  defHttp.get<ResponseData<UserInfo>>({
    url: '/user/info/updatePassword',
    params: {
      passWord,
    },
  });
